@if (form) {
	<form [formGroup]="form">
		<div class="u-row">
			<tvcore-input class="u-col-sm--12 u-col--4" [label]="'BOOKING.CAMP_FORM.NAME' | translate" name="camp" [showErrors]="showErrors">
				<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
			</tvcore-input>

			<tvcore-input class="u-col-sm--12 u-col--4" [label]="'BOOKING.CAMP_FORM.LOCATION' | translate" name="location" [showErrors]="showErrors">
				<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
			</tvcore-input>
		</div>

		<div class="u-row">
			<tvcore-datepicker class="u-col-sm--12 u-col--4" [label]="'BOOKING.CAMP_FORM.START_DATE' | translate" name="startDate" icon="date" [showErrors]="showErrors">
				<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
			</tvcore-datepicker>

			<tvcore-datepicker class="u-col-sm--12 u-col--4" [label]="'BOOKING.CAMP_FORM.END_DATE' | translate" name="endDate" icon="date" [showErrors]="showErrors">
				<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
			</tvcore-datepicker>
		</div>
	</form>
}
